import { Record, List } from 'immutable';

export default class StreetPakingGeometry extends Record({
  lat: null,
  lng: null,
}) {
  constructor(props) {
    if (!props) {
      super();
      return;
    }

    super({
      lat: props.lat,
      lng: props.lng,
    });
  }
}

export const StreetParkingGeometries = (geometries => (List(geometries.map(g => new StreetPakingGeometry(g)))));
